import { Button } from '~/components/ui/Button';
import * as Tooltip from '~/components/ui/Tooltip';
import type { PricingCardAction } from '~/lib/stores/pricing/types';

interface Props {
  action: PricingCardAction;
  loading: boolean;
  disabled: boolean;
}

export const PricingCardActionButton = ({ action, loading, disabled }: Props) => {
  if (action.tooltipText) {
    return (
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <Button
              size="lg"
              variant={action.variant}
              onClick={action.onClick}
              disabled={disabled || action.disabled}
              loading={loading}
              color={action.color}
            >
              {action.text}
            </Button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              side="bottom"
              avoidCollisions
              collisionPadding={10}
              sideOffset={6}
              maxWidth={250}
              truncate={false}
            >
              <span>{action.tooltipText}</span>
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    );
  }

  return (
    <Button
      size="lg"
      variant={action.variant}
      onClick={action.onClick}
      disabled={disabled || action.disabled}
      loading={loading}
      color={action.color}
    >
      {action.text}
    </Button>
  );
};
